module.exports = __webpack_public_path__ + "static/img/11.d6309b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/zh/11.png
// module id = HIRC
// module chunks = 0